module.exports = __webpack_public_path__ + "static/img/chrome.d47ac6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chrome.png
// module id = AluB
// module chunks = 3